exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-list>.btn[data-v-253acf87]:not(:last-child),.btn-list>.dropdown[data-v-253acf87]:not(:last-child){margin-right:.5rem}.btn-list>.btn[data-v-253acf87],.btn-list>.dropdown[data-v-253acf87]{margin-bottom:.5rem}", ""]);

// exports
